import React, { useEffect, useRef, useState } from "react";
import "../../../common/DropdownCustomStyles.css";
import { useDispatch, useSelector } from "react-redux";
import {
  ContactContainer,
  ItemContainer,
  LabelContainer,
  ErrorContainer,
  FormContainer,
  CustomisedPrimeInput,
  LabelValueContainer,
} from "../../../myContract/ContactMe.styles";
import { Wrapper, CPButton, TextWrapperSpan } from "../../../../constants/common/StyledGlobalConstants";
import "./AddressDetailsForm.css";
import * as Actions from "./../../../../store/actions/schedulingportal/technicianAppointment";
import { ADDRESS_REGEX, ZIP_REGEX, CITY_REGEX } from "../../../../util/regexUtils";
import styled from "styled-components";
import { RadioButtonGroup } from "@vds/radio-buttons";
import { StarSpan } from "../../VehicleorAssetDetails/CamerasAndOtherAccessories";
import { handleCountryStates } from "../../../../util/addressUtils";
import CPNotification from "../../../../pages/Login/CPNotification";
import { getPendoId } from "../../../../util/cfstPendoUtils";
import { DEVICE_BREAKPOINTS } from "../../../../constants/appConstants";
import Select from "react-select";
import AccessibleDropdown from "./AccessibleDropdown/AccessibleDropdown";
import PropTypes from "prop-types";

const { TABLET, DESKTOP } = DEVICE_BREAKPOINTS;

export const UltraMediumText = styled.p`
  font-family: "Neue Haas Grotesk Text Std";
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "0px")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "14px")};
  font-weight: 700;
  line-height: ${(props) => props.lineHeight};
`;

const RadioButtonGroupWrapper = styled.div`
div[role="radiogroup"]:first-child {
  margin-bottom: 1rem;
  }
  div[role="radiogroup"] {

    > div > label {
      > div:first-child > div {
        height: 1rem;
        width: 1rem;
        transform: translate(0%, 100%);
      }
       > div:nth-child(2) {
           padding: 0 0 0 7px;
       }
        > div > span > span {
          font-family: Neue Haas Grotesk Text Std;
          font-size: 16px !important;
          font-weight: 700;
          line-height: 22px !important;
        }
        font-family: Neue Haas Grotesk Text Std;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
       
      }
    }
  }
`;

const AddressValidationFailed = styled.div`
  height: 300px;
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  p {
    font-family: Neue Haas Grotesk Text Std;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    width: 100%;
    margin: 0;
  }
  a {
    font-family: Neue Haas Grotesk Text Std;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #0077b4;
    width: 100%;
    cursor: pointer;
  }
`;

const CustomWrapper = styled(Wrapper)`
  color: #0077b4;
  cursor: pointer;
  font-family: neue-haas-grotesk-display;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1rem;
  padding: 0.75rem 0rem;

  &:focus {
    outline: auto 1px;
  }
`;

function getOptionBackgroundColor(state) {
  if (state.isFocused) {
    return "#0000000D";
  }
  if (state.isSelected) {
    return "var(--background-secondary, #F6F6F6)";
  }
  return "transparent";
};

const AddressDetailsForm = (props) => {
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const MARGIN_TOP_MOBILE = "1rem";
  const MARGIN_TOP_DESKTOP = "1.5rem";
  const isDesktop = windowSize.width >= TABLET;
  const containerWidth = "54%";
  const { userSelectedAddressOption, statesData, isSuggestedAddress, addressFormValues, accountDetails, isValidateAddressApi } = useSelector(
    (state) => state.TECHNICIANAPPOINTMENT
  );

  const dispatch = useDispatch();
  const [address, setAddress] = useState("");
  const [isSelectedExistingAddress, setIsSelectedExistingAddress] = useState(false);
  const [isValidateAddressButtonEnabled, setIsValidateAddressButtonEnabled] = useState(false);
  const [address1, setAddress1] = useState({
    errorText: "",
    value: "",
    isError: false,
    disabled: false,
    success: false,
  });
  const [address2, setAddress2] = useState({
    errorText: "",
    value: "",
    isError: false,
    disabled: false,
    success: false,
  });
  const [city, setCity] = useState({
    errorText: "",
    value: "",
    isError: false,
    disabled: false,
    success: false,
  });
  const [state, setState] = useState({
    errorText: "",
    value: "",
    isError: false,
    disabled: false,
    success: false,
  });
  const [country, setCountry] = useState({
    errorText: "",
    value: "United States",
    isError: false,
    disabled: false,
    success: false,
  });
  const [zip, setZIP] = useState({
    errorText: "",
    value: "",
    isError: false,
    disabled: false,
    success: false,
  });

  const [isValidateRadio, setIsValidateRadio] = useState(null);
  const [isValidatedRadioChanges, setIsValidatedRadioChanges] = useState(false);

  const [existingAddressList, setExistingAddressList] = useState([]);

  const address1Ref = useRef(null);
  const address2Ref = useRef(null);
  const cityRef = useRef(null);
  const zipRef = useRef(null);
  const stateRef = useRef(null);
  const countryRef = useRef(null);
  const tryAgainRef = useRef(null);
  const [localVarForAriaLabel, setLocalVarForAriaLabel] = useState(true);

  useEffect(() => {
    accountDetails?.data?.addresses?.length === 0 && setLocalVarForAriaLabel(false);
  }, [accountDetails?.data?.addresses]);

  useEffect(() => {
    if (userSelectedAddressOption === "add-new-address") {
      if (address1.isError) {
        address1Ref?.current.focus();
      } else if (address2.isError) {
        address2Ref?.current.focus();
      } else if (city.isError) {
        cityRef?.current.focus();
      } else if (state.isError) {
        stateRef?.current.focus();
      } else if (country.isError) {
        countryRef?.current.focus();
      } else if (zip.isError) {
        zipRef?.current.focus();
      } else if (addressFormValues?.newAddress?.addressFound === "addressNotFound") {
        address1Ref?.current.focus();
      }
    }
  }, [
    userSelectedAddressOption,
    address1.isError,
    address2.isError,
    city.isError,
    state.isError,
    country.isError,
    zip.isError,
    addressFormValues?.newAddress?.addressFound,
  ]);

  //Call stateList api when user clicks on Add new address radio button
  useEffect(() => {
    if (userSelectedAddressOption === "add-new-address" && !statesData?.statesList?.length) dispatch(Actions.fetchStates());
  }, []);

  useEffect(() => {
    if (userSelectedAddressOption === "use-existing-address" && !address) {
      setIsSelectedExistingAddress(false);
    } else {
      setIsSelectedExistingAddress(true);
    }
  }, [userSelectedAddressOption, address]);

  useEffect(() => {
    if (address1.success && !address2.isError && city.success && state.success && zip.success) {
      setIsValidateAddressButtonEnabled(true);
    } else {
      setIsValidateAddressButtonEnabled(false);
    }
  }, [address1.success, address2.success, city.success, state.success, zip.success, addressFormValues]);

  const validateAddressButtonCheck = () => {
    const standardizedInfo = addressFormValues?.newAddress?.standardizedInfo;
    const standardizedAddress = standardizedInfo?.standardizedAddress;
    const postalCodeBase = standardizedAddress?.postalCodeBase || "";
    // Only use 5-digit ZIP for comparison
    const standardizedZip = postalCodeBase;
    const isZipSame = standardizedZip === zip.value;
    if (userSelectedAddressOption === "add-new-address") {
      if (
        (addressFormValues.newAddress.formAddress.address1 !== address1.value ||
          addressFormValues.newAddress.formAddress.address2 !== address2.value ||
          addressFormValues.newAddress.formAddress.city !== city.value ||
          addressFormValues.newAddress.formAddress.state !== state.value ||
          (addressFormValues.newAddress.formAddress.zip !== zip.value ? !isZipSame : addressFormValues.newAddress.formAddress.zip !== zip.value)) &&
        !address1.isError &&
        !address2.isError &&
        !city.isError &&
        !state.isError &&
        !zip.isError
      ) {
        setIsValidateAddressButtonEnabled(true);
      } else {
        setIsValidateAddressButtonEnabled(false);
      }
    }
  };

  const validateAddressDetailsForm = (field, value) => {
    if (isValidatedRadioChanges) {
      if (address1.success && !address2.isError && city.success && state.success && zip.success) {
        setIsValidateAddressButtonEnabled(true);
      }
    }

    const validateField = (regex, value, fieldName, setStateFn, requiredError, invalidError) => {
      if (value.length && value.toLowerCase() !== "null") {
        if (regex.test(value)) {
          setStateFn({ value, isError: false, errorText: "", success: true, disabled: false });
        } else {
          setStateFn({ value, isError: true, errorText: invalidError, success: false, disabled: false });
        }
      } else {
        setStateFn({ value, isError: true, errorText: requiredError, success: false, disabled: false });
      }
    };

    const validateDropdownField = (value, setStateFn, requiredError) => {
      if (value) {
        setStateFn((prevState) => ({
          ...prevState,
          value,
          isError: false,
          errorText: "",
          success: true,
          disabled: false,
        }));
      } else {
        setStateFn((prevState) => ({
          ...prevState,
          value,
          isError: true,
          errorText: requiredError,
          success: false,
          disabled: false,
        }));
      }
    };

    switch (field) {
      case "address1":
        validateField(ADDRESS_REGEX, value, "address1", setAddress1, "Address line 1 is required", "Please enter a valid address line 1");
        break;

      case "address2":
        // Address line 2 is optional: if empty, no error
        if (!value || value.trim() === "" || value.toLowerCase() === "null") {
          setAddress2({ value, isError: false, errorText: "", success: true, disabled: false });
        } else if (ADDRESS_REGEX.test(value)) {
          setAddress2({ value, isError: false, errorText: "", success: true, disabled: false });
        } else {
          setAddress2({ value, isError: true, errorText: "Please enter a valid address line 2", success: false, disabled: false });
        }
        break;

      case "city":
        validateField(CITY_REGEX, value, "city", setCity, "City/town is required", "Please enter a valid city/town");
        break;

      case "state":
        validateDropdownField(value, setState, "State is required");
        break;

      case "country":
        validateDropdownField(value, setCountry, "Country is required");
        break;

      case "zip":
        validateField(ZIP_REGEX, value, "zip", setZIP, "ZIP is required", "Please enter a valid ZIP");
        break;

      default:
        break;
    }
  };
  const handleExistingAddressSelection = (value) => {
    setAddress(value);
    const selectedAddress = toCreateAddressList(accountDetails?.data?.addresses).filter(
      (adrs) => adrs.completeAddressToDisplay.toLowerCase() === value.toLowerCase()
    );
    dispatch(Actions.getExistingAddressValue(selectedAddress[0]));
    props.setAddressFormSuccess(true);
  };

  const handleValidateAddress = () => {
    const payload = {
      inputAddress: {
        addressLine1: address1.value,
        addressLine2: address2.value ?? "",
        city: city.value,
        stateProvince: state.value,
        postalCode: zip.value,
        country: country.value,
      },
    };

    dispatch(Actions.technicianAppointmentValidateAddress(payload));
    setIsValidateAddressButtonEnabled(false);
    setIsValidateRadio("reset");

    if (address1.value && !address2.isError && city.value && country.value && zip.value && state.value) {
      let data = {
        address1: address1.value,
        address2: address2.value,
        city: city.value,
        state: state.value,
        country: country.value,
        zip: zip.value,
      };

      dispatch(Actions.getAddressValue(data));
    }
    setIsValidateAddressButtonEnabled(false);
    setIsValidatedRadioChanges(true);
  };

  useEffect(() => {
    const formAddress = addressFormValues?.newAddress?.formAddress;
    const inputAddress = addressFormValues?.newAddress?.inputAddress;
    if (formAddress) {
      setAddress1((prevState) => {
        return { ...prevState, value: formAddress.address1 };
      });
      setAddress2((prevState) => {
        return { ...prevState, value: formAddress.address2 };
      });
      setCity((prevState) => {
        return { ...prevState, value: formAddress.city };
      });
      setState((prevState) => {
        return { ...prevState, value: formAddress.state };
      });

      // Only show 5-digit ZIP code
      let zipToShow = formAddress.zip; // Default to form value (user input - already 5 digits)
      if (formAddress.zip !== inputAddress.postalCode) {
        // This is from standardized address - use only the base postal code (5 digits)
        zipToShow = addressFormValues.newAddress.standardizedInfo.standardizedAddress.postalCodeBase;
      }

      setZIP((prevState) => {
        return { ...prevState, value: zipToShow };
      });
    }

    if (Object.keys(addressFormValues.newAddress.formAddress).length > 0) {
      props.setAddressFormSuccess(true);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(addressFormValues.newAddress.formAddress).length > 0) {
      validateAddressButtonCheck();
      if (
        address1.isError ||
        address2.isError ||
        city.isError ||
        country.isError ||
        zip.isError ||
        state.isError ||
        isValidateAddressButtonEnabled ||
        isValidatedRadioChanges
      ) {
        props.setAddressFormSuccess(false);
      } else {
        props.setAddressFormSuccess(true);
      }

      if (
        userSelectedAddressOption === "use-existing-address" &&
        (!addressFormValues?.existingAddress?.address1 ||
          !addressFormValues?.existingAddress?.city ||
          !addressFormValues?.existingAddress?.stateCode ||
          !addressFormValues?.existingAddress?.country ||
          !addressFormValues?.existingAddress?.zipCode)
      ) {
        props.setAddressFormSuccess(false);
      }
    }
  }, [address1, address2, city, country, zip, state, isValidatedRadioChanges, isValidateAddressButtonEnabled, addressFormValues, address]);

  const handleValidAddressChange = (value) => {
    setIsValidateRadio(value);
    let data;
    if (value === "suggested") {
      setAddress1({
        value: addressFormValues.newAddress.standardizedInfo.standardizedAddress.addressLine1,
        isError: false,
        errorText: "",
        success: true,
        disabled: false,
      });
      setAddress2({
        value: addressFormValues.newAddress.standardizedInfo.standardizedAddress.addressLine2,
        isError: false,
        errorText: "",
        success: true,
        disabled: false,
      });
      setCity({
        value: addressFormValues.newAddress.standardizedInfo.standardizedAddress.city,
        isError: false,
        errorText: "",
        success: true,
        disabled: false,
      });
      setState({
        value: addressFormValues.newAddress.standardizedInfo.standardizedAddress.stateProvince,
        isError: false,
        errorText: "",
        success: true,
        disabled: false,
      });
      setCountry({
        //  value: addressFormValues.newAddress.standardizedInfo.iso3CountryCode,
        value: "United States",
        isError: false,
        errorText: "",
        success: true,
        disabled: false,
      });
      setZIP({
        value: addressFormValues.newAddress.standardizedInfo.standardizedAddress.postalCodeBase,
        isError: false,
        errorText: "",
        success: true,
        disabled: false,
      });

      data = {
        address1: addressFormValues.newAddress.standardizedInfo.standardizedAddress.addressLine1,
        address2: addressFormValues.newAddress.standardizedInfo.standardizedAddress.addressLine2,
        city: addressFormValues.newAddress.standardizedInfo.standardizedAddress.city,
        state: addressFormValues.newAddress.standardizedInfo.standardizedAddress.stateProvince,
        country: "United States",
        zip: addressFormValues.newAddress.standardizedInfo.standardizedAddress.postalCodeBase,
      };
    } else {
      setAddress1({ value: addressFormValues.newAddress.inputAddress.addressLine1, isError: false, errorText: "", success: true, disabled: false });
      setAddress2({ value: addressFormValues.newAddress.inputAddress.addressLine2, isError: false, errorText: "", success: true, disabled: false });
      setCity({ value: addressFormValues.newAddress.inputAddress.city, isError: false, errorText: "", success: true, disabled: false });
      setState({ value: addressFormValues.newAddress.inputAddress.stateProvince, isError: false, errorText: "", success: true, disabled: false });
      setCountry({ value: "United States", isError: false, errorText: "", success: true, disabled: false });
      setZIP({ value: addressFormValues.newAddress.inputAddress.postalCode, isError: false, errorText: "", success: true, disabled: false });
      data = {
        address1: addressFormValues.newAddress.inputAddress.addressLine1,
        address2: addressFormValues.newAddress.inputAddress.addressLine2,
        city: addressFormValues.newAddress.inputAddress.city,
        state: addressFormValues.newAddress.inputAddress.stateProvince,
        country: "United States",
        zip: addressFormValues.newAddress.inputAddress.postalCode,
      };
    }
    setIsValidatedRadioChanges(false);
    props.setAddressFormSuccess(true);

    dispatch(Actions.getAddressValue(data));
  };

  //To retrieve the address list along with a new value (to consolidate the complete address)
 const toCreateAddressList = (accountAddresses) => {
  let newAddress = [];
  accountAddresses?.map((addressFields, index) => {
    // Ensure ZIP code is only 5 digits for display
    const zipCode5Digit = addressFields.zipCode ? addressFields.zipCode.substring(0, 5) : "";
    
    newAddress.push({
      addressID: `adrs${index + 1}`,
      ...addressFields,
      state: handleCountryStates(addressFields.stateCode),
      completeAddressToDisplay: addressFields.address2
        ? `${addressFields.address1}, ${addressFields.address2}, ${addressFields.city}, ${handleCountryStates(addressFields.stateCode)} ${zipCode5Digit}, ${addressFields.country}`
        : `${addressFields.address1}, ${addressFields.city}, ${handleCountryStates(addressFields.stateCode)} ${zipCode5Digit}, ${addressFields.country}`,
    });
  });
  return newAddress;
};

  useEffect(() => {
    if (!isValidateAddressApi && userSelectedAddressOption === "add-new-address") {
      tryAgainRef.current.focus();
    }
  }, [isValidateAddressApi, userSelectedAddressOption]);

  //to save the list of address into the local variable
  useEffect(() => {
    if (accountDetails?.data?.addresses) {
      setExistingAddressList(toCreateAddressList(accountDetails?.data?.addresses));
    }
    if (addressFormValues?.existingAddress?.completeAddressToDisplay) {
      handleExistingAddressSelection(addressFormValues?.existingAddress?.completeAddressToDisplay);
    }

    if (userSelectedAddressOption === "add-new-address") {
      if (!address1.value && !city.value && !zip.value && !state.value) {
        props.setAddressFormSuccess(false);
      }
    }
  }, [userSelectedAddressOption]);

  return (
    <div style={{ marginTop: `${windowSize.width < TABLET ? MARGIN_TOP_MOBILE : MARGIN_TOP_DESKTOP}` }}>
      <Wrapper display="flex" flexDirection="column" width={windowSize.width <= 480 ? "auto" : "100%"}>
        {userSelectedAddressOption === "use-existing-address" && (
          <>
            <FormContainer desktop={windowSize.width >= TABLET} style={{ width: "100%" }}>
              <ContactContainer desktop={isDesktop} width={containerWidth}>
                <AccessibleDropdown
                  options={existingAddressList.map((adrs) => ({
                    label: adrs.completeAddressToDisplay,
                    value: adrs.completeAddressToDisplay,
                  }))}
                  value={{ label: address, value: address }}
                  onChange={(selectedOption) => handleExistingAddressSelection(selectedOption?.value)}
                  id={getPendoId("select-existing-address-dropdown")}
                  placeholder="Select existing address"
                  isDisabled={existingAddressList?.length === 0}
                />
              </ContactContainer>
            </FormContainer>

            {existingAddressList?.length === 0 && (
              <div style={{ marginTop: "1rem", width: "100%" }} aria-hidden={localVarForAriaLabel}>
                <CPNotification isOpen={true} notificationType="cfsterror" width="100%" height="auto">
                  <Wrapper>
                    <TextWrapperSpan fontSize="14px" fontWeight="400" lineHeight="20px" margin="0">
                      We're having trouble retrieving the existing address. Enter the address manually in the <b>Add new address</b> field.
                      {" "}
                      <span className="sr-only" tabIndex="-1">Please press up or down arrow to select Add New Address.</span>
                    </TextWrapperSpan>
                  </Wrapper>
                </CPNotification>
              </div>
            )}
            {address !== "" &&
              (!addressFormValues?.existingAddress?.address1 ||
                !addressFormValues?.existingAddress?.city ||
                !addressFormValues?.existingAddress?.stateCode ||
                !addressFormValues?.existingAddress?.country ||
                !addressFormValues?.existingAddress?.zipCode) && (
                <div style={{ marginTop: "1rem" }}>
                  <CPNotification isOpen={true} notificationType="cfsterror" width="100%" height="auto">
                    <Wrapper>
                      <TextWrapperSpan fontSize="14px" fontWeight="400" lineHeight="20px" margin="0">
                        One are more fields missing in existing address, please select the new address
                      </TextWrapperSpan>
                    </Wrapper>
                  </CPNotification>
                </div>
              )}
            {isSelectedExistingAddress && (
              <Wrapper display="flex" flexDirection="column" gap="8px" desktop={windowSize.width >= TABLET} width="100%" marginTop="1.5rem">
                <LabelValueContainer>
                  <label>{"Address"}:</label>
                  <span className="info">{`${addressFormValues?.existingAddress?.address1 || ""} ${addressFormValues?.existingAddress?.address2 || ""
                    }`}</span>
                </LabelValueContainer>

                <LabelValueContainer>
                  <label>{"City/town"}:</label>
                  <span className="info">{addressFormValues?.existingAddress?.city || ""}</span>
                </LabelValueContainer>

                <LabelValueContainer>
                  <label>{"State/province"}:</label>
                  <span className="info">{addressFormValues?.existingAddress?.stateCode || ""}</span>
                </LabelValueContainer>

                <LabelValueContainer>
                  <label>{"Country/region"}:</label>
                  <span className="info">{addressFormValues?.existingAddress?.country || ""}</span>
                </LabelValueContainer>

                <LabelValueContainer>
                  <label>{"ZIP"}:</label>
                  <span className="info">
                    {addressFormValues?.existingAddress?.zipCode
                      ? addressFormValues.existingAddress.zipCode.substring(0, 5)
                      : ""}
                  </span>
                </LabelValueContainer>
              </Wrapper>
            )}
          </>
        )}
        {!isValidateAddressApi && userSelectedAddressOption === "add-new-address" && (
          <AddressValidationFailed>
            <p>Something went wrong.</p>
            <CustomWrapper
              id={getPendoId("validate-address-failed-try-again-button")}
              onClick={handleValidateAddress}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleValidateAddress()}
              ref={tryAgainRef}
              aria-live="assertive"
              role="alert"
              tabIndex="0"
              aria-label="Something went wrong. Click to activate. Try again"
            >
              Try Again
            </CustomWrapper>
          </AddressValidationFailed>
        )}

        {isValidateAddressApi && userSelectedAddressOption === "add-new-address" && (
          <>
            {addressFormValues?.newAddress?.addressFound === "addressNotFound" && (
              <CPNotification isOpen={true} notificationType="cfsterror" width="100%" height="auto" margin="0 0 24px 0">
                <Wrapper>
                  <TextWrapperSpan fontSize="14px" fontWeight="400" lineHeight="20px">
                    We couldn’t validate the address you entered. Review all fields for accuracy.{" "}
                    <span className="sr-only" tabIndex="-1">Please check the entered address and update, wherever is required.</span>
                  </TextWrapperSpan>
                </Wrapper>
              </CPNotification>
            )}
            <ContactContainer desktop={windowSize.width >= DESKTOP} width="100%">
              <ItemContainer>
                <LabelContainer>
                  <label>{"Address line 1"}</label> <StarSpan>*</StarSpan>
                </LabelContainer>
                <div>
                  <CustomisedPrimeInput
                    style={{
                      textOverflow: "ellipsis",
                    }}
                    errorBorder={addressFormValues?.newAddress?.addressFound === "addressNotFound" && "red"}
                    id="address-line-one"
                    value={address1.value}
                    ariaLabel={"Enter street address, P.O. box, company name, c/o"}
                    placeholder={"Enter street address, P.O. box, company name, c/o"}
                    errorText={address1.errorText}
                    disabled={address1.disabled}
                    onChange={(e) => validateAddressDetailsForm("address1", e.target.value)}
                    errorBorderOnError={address1.isError}
                    ref={address1Ref}
                  />
                </div>
                {address1.isError && (
                  <ErrorContainer role="alert" tabIndex="-1" aria-live="assertive">
                    {address1.errorText}
                  </ErrorContainer>
                )}
              </ItemContainer>
            </ContactContainer>
            <ContactContainer desktop={windowSize.width >= DESKTOP} width="100%" marginTop={windowSize.width < DESKTOP ? "2rem" : "1.5rem"}>
              <ItemContainer>
                <LabelContainer>
                  <label>{"Address line 2 "}</label>
                </LabelContainer>
                <div>
                  <CustomisedPrimeInput
                    style={{ textOverflow: "ellipsis" }}
                    id="address-line-two"
                    value={address2.value || ""}
                    ariaLabel={"Enter apartment, suite, unit, building, floor, etc."}
                    placeholder={"Enter apartment, suite, unit, building, floor, etc."}
                    errorText={address2.errorText}
                    disabled={address2.disabled}
                    onChange={(e) => validateAddressDetailsForm("address2", e.target.value)}
                    ref={address2Ref}
                  />
                </div>
                {address2.isError && (
                  <ErrorContainer role="alert" tabIndex="-1" aria-live="assertive">
                    {address2.errorText}
                  </ErrorContainer>
                )}
              </ItemContainer>
            </ContactContainer>
            <FormContainer
              desktop={windowSize.width >= TABLET}
              style={{ width: "100%", marginTop: `${windowSize.width < TABLET ? "2rem" : "1.5rem"}` }}
            >
              <ContactContainer desktop={windowSize.width >= DESKTOP} width="50%">
                <ItemContainer>
                  <LabelContainer>
                    <label> {"City/town"}</label>
                    <StarSpan>*</StarSpan>
                  </LabelContainer>
                  <div>
                    <CustomisedPrimeInput
                      style={{ textOverflow: "ellipsis" }}
                      errorBorder={addressFormValues?.newAddress?.addressFound === "addressNotFound" && "red"}
                      id="add-contact-city-town"
                      value={city.value}
                      ariaLabel={"Enter city/town"}
                      placeholder={"Enter city/town"}
                      errorText={city.errorText}
                      disabled={city.disabled}
                      onChange={(e) => validateAddressDetailsForm("city", e.target.value)}
                      errorBorderOnError={city.isError}
                      ref={cityRef}
                    />
                  </div>
                  {city.isError && (
                    <ErrorContainer role="alert" tabIndex="-1" aria-live="assertive">
                      {city.errorText}
                    </ErrorContainer>
                  )}
                </ItemContainer>
              </ContactContainer>
              <ContactContainer desktop={windowSize.width >= DESKTOP} width="50%">
                <ItemContainer>
                  <LabelContainer>
                    <label> {"State/province"}</label>
                    <StarSpan>*</StarSpan>
                  </LabelContainer>
                  <div>
                    <Select
                      isSearchable={true}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          height: "2.75rem",
                          border: state.isFocused ? "2px solid var(--feedback-information, #006FC1)" : "1px solid #d8dada",
                          borderRadius: "4px",
                          fontSize: "0.875rem",
                          fontFamily: '"neue-haas-grotesk-text"',
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          backgroundColor: state.isFocused ? "var(--background-secondary, #F6F6F6)" : "#fff",
                          flexWrap: "nowrap",
                          boxShadow: "none",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontFamily: "neue-haas-grotesk-text",
                          fontWeight: 400,
                          fontSize: "14px",
                          color: "#000",
                        }),
                        indicatorSeparator: () => ({
                          display: "none",
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 9999,
                          backgroundColor: "#fff",
                          border: "1px solid #d8dada",
                          fontSize: "0.875rem",
                          fontFamily: '"neue-haas-grotesk-text"',
                          borderRadius: "4px",
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color: "#000",
                          fontSize: "0.875rem",
                          fontFamily: '"neue-haas-grotesk-text"',
                          fontWeight: 400,
                        }),
                        option: (base, state) => ({
                          ...base,
                          paddingTop: "14px", // Top padding
                          paddingRight: "16px", // Right padding
                          paddingBottom: "14px", // Bottom padding
                          paddingLeft: "16px", // Left padding
                          gap: "10px", // Gap between options
                          fontSize: "0.875rem",
                          fontWeight: 400,
                          fontFamily: '"neue-haas-grotesk-text"',
                          color: "#000",
                          backgroundColor: getOptionBackgroundColor(state),
                          cursor: "pointer",
                          padding: "0.5rem",
                          borderLeft: state.isSelected ? "4px solid #EE0000" : "4px solid transparent",
                          "&:active": {
                            backgroundColor: "#0000001F",
                          },
                        }),
                      }}
                      errorBorder={addressFormValues?.newAddress?.addressFound === "addressNotFound"}
                      tabIndex="0"
                      id="select-state-dropdown"
                      value={
                        statesData?.statesList
                          ?.map((item) => ({ label: item.stateCode, value: item.erpStateCode }))
                          .find((option) => option.value === state.value) || null
                      }
                      aria-label={"State/province"}
                      isDisabled={state.disabled}
                      placeholder="Select state/province"
                      onChange={(selectedOption) => validateAddressDetailsForm("state", selectedOption?.value)}
                      options={statesData?.statesList?.map((item) => ({
                        label: item.stateCode,
                        value: item.erpStateCode,
                      }))}
                    />
                  </div>
                  {state.isError && (
                    <ErrorContainer role="alert" tabIndex="-1" aria-live="assertive">
                      {state.errorText}
                    </ErrorContainer>
                  )}
                </ItemContainer>
              </ContactContainer>
            </FormContainer>
            <FormContainer
              desktop={windowSize.width >= TABLET}
              style={{ width: "100%", marginTop: `${windowSize.width < TABLET ? "2rem" : "1.5rem"}` }}
            >
              <ContactContainer desktop={windowSize.width >= DESKTOP} width="50%">
                <ItemContainer>
                  <LabelContainer>
                    <label> {"Country/region"}</label>
                    <StarSpan>*</StarSpan>
                  </LabelContainer>
                  <div>
                    <Select
                      tabIndex="0"
                      id="select-existing-address-country"
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          height: "2.75rem",
                          border: state.isFocused ? "2px solid var(--feedback-information, #006FC1)" : "1px solid #d8dada",
                          borderRadius: "4px",
                          fontSize: "0.875rem",
                          fontFamily: '"neue-haas-grotesk-text"',
                          display: "flex",
                          alignItems: "center",
                          cursor: "not-allowed", // Disable pointer events
                          backgroundColor: "#f2f2f2",
                          flexWrap: "nowrap",
                          boxShadow: "none",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontFamily: "neue-haas-grotesk-text",
                          fontWeight: 400,
                          fontSize: "14px",
                          color: "#000",
                        }),
                        indicatorSeparator: () => ({
                          display: "none",
                        }),
                        menu: (base) => ({
                          ...base,
                          display: "none", // Hide the dropdown menu since there's only one option
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color: "#000",
                          fontSize: "0.875rem",
                          fontFamily: '"neue-haas-grotesk-text"',
                          fontWeight: 400,
                        }),
                        option: (base, state) => ({
                          ...base,
                          paddingTop: "14px", // Top padding
                          paddingRight: "16px", // Right padding
                          paddingBottom: "14px", // Bottom padding
                          paddingLeft: "16px", // Left padding
                          gap: "10px", // Gap between options
                          fontSize: "0.875rem",
                          fontWeight: 400,
                          fontFamily: '"neue-haas-grotesk-text"',
                          color: "#000",
                          backgroundColor: getOptionBackgroundColor(state),
                          cursor: "pointer",
                          padding: "0.5rem",
                          borderLeft: state.isSelected ? "4px solid #EE0000" : "4px solid transparent",
                          "&:active": {
                            backgroundColor: "#0000001F",
                          },
                        }),
                      }}
                      value={{ label: country.value, value: country.value }}
                      aria-label={"Select existing address country/region"}
                      isDisabled={true}
                      placeholder="Select country/region"
                      onChange={(selectedOption) => validateAddressDetailsForm("country", selectedOption?.value)}
                      options={[{ label: "United States", value: "United States" }]}
                    />
                  </div>
                  {country.isError && (
                    <ErrorContainer role="alert" tabIndex="-1" aria-live="assertive">
                      {country.errorText}
                    </ErrorContainer>
                  )}
                </ItemContainer>
              </ContactContainer>
              <ContactContainer desktop={windowSize.width >= DESKTOP} width="50%">
                <ItemContainer>
                  <LabelContainer>
                    <label> {"ZIP"}</label>
                    <StarSpan>*</StarSpan>
                  </LabelContainer>
                  <div>
                    <CustomisedPrimeInput
                      id="add-contact-city-town"
                      errorBorder={addressFormValues?.newAddress?.addressFound === "addressNotFound" && "red"}
                      value={zip.value}
                      errorText={zip.errorText}
                      ariaLabel={"Enter ZIP"}
                      placeholder={"Enter ZIP"}
                      disabled={zip.disabled}
                      onChange={(e) => validateAddressDetailsForm("zip", e.target.value)}
                      errorBorderOnError={zip.isError}
                      ref={zipRef}
                      maxLength="5"
                    />
                  </div>
                  {zip.isError && (
                    <ErrorContainer role="alert" tabIndex="-1" aria-live="assertive">
                      {zip.errorText}
                    </ErrorContainer>
                  )}
                </ItemContainer>
              </ContactContainer>
            </FormContainer>
          </>
        )}
      </Wrapper>
      {userSelectedAddressOption === "add-new-address" && isValidateAddressApi && (
        <Wrapper marginTop={windowSize.width < TABLET ? "2rem" : "1.5rem"}>
          <CPButton
            id={getPendoId("validate-address-button")}
            ariaLabel="VALIDATE ADDRESS"
            size="large"
            fontSize="14px"
            fontPaddingLeft="1rem"
            fontPaddingRight="1rem"
            boxButton={true}
            disabled={addressFormValues?.newAddress?.addressFound === "addressNotFound" ? false : isValidateAddressButtonEnabled === false}
            buttonWidth={windowSize.width < TABLET ? "100%" : "auto"}
            onClick={handleValidateAddress}
          >
            VALIDATE ADDRESS
          </CPButton>
          {isSuggestedAddress && (
            <div>
              <UltraMediumText eDSFont fontSize="20px" marginBottom="1rem" lineHeight="1.5rem" marginTop="1.5rem">
                Recommendation
              </UltraMediumText>
              <p style={{ fontSize: "14px", lineHeight: "20px", fontWeight: "400", marginBottom: "16px" }}>
                We couldn’t find an exact match for the address you entered. Please choose one of the following options to proceed:
              </p>
              <RadioButtonGroupWrapper>
                <RadioButtonGroup
                  onChange={() => handleValidAddressChange("suggested")}
                  error={false}
                  defaultValue={isValidateRadio === null ? "none" : isValidateRadio}
                  value={isValidateRadio}
                  id={getPendoId("suggested-address-radio-button")}
                  data={[
                    {
                      name: "group",
                      label: <span>{"Use verified address (recommended)"}</span>,
                      children: (() => {
                        const standardizedAddress = addressFormValues?.newAddress?.standardizedInfo?.standardizedAddress;
                        const zipCode5Digit = standardizedAddress?.postalCodeBase || "";

                        return `${standardizedAddress?.addressLine1 || ""}, ${standardizedAddress?.addressLine2 ? standardizedAddress.addressLine2 + ", " : ""
                          }${standardizedAddress?.city || ""}, ${standardizedAddress?.stateProvince || ""
                          } ${zipCode5Digit}, USA`;
                      })(),
                      value: "suggested",
                      ariaLabel: "Use suggested address",
                    },
                  ]}
                />
                <RadioButtonGroup
                  onChange={() => handleValidAddressChange("typed")}
                  error={false}
                  defaultValue={isValidateRadio === null ? "none" : isValidateRadio}
                  value={isValidateRadio}
                  id={getPendoId("typed-address-radio-button")}
                  data={[
                    {
                      name: "group",
                      label: <span>Proceed with my address</span>,
                      children: (() => {
                        const inputAddress = addressFormValues.newAddress.inputAddress;
                        // User input is already 5 digits due to input restrictions
                        const inputZipCode = inputAddress.postalCode || "";

                        return `${inputAddress.addressLine1}, ${inputAddress.addressLine2 || ""
                          }${inputAddress.addressLine2 ? "," : ""}  ${inputAddress.city}, ${inputAddress.stateProvince
                          }, ${inputZipCode}, ${inputAddress.country === "United States" ? "USA" : inputAddress.country
                          }`;
                      })(),
                      value: "typed",
                      ariaLabel: "Use address as typed",
                    },
                  ]}
                />
              </RadioButtonGroupWrapper>
            </div>
          )}
        </Wrapper>
      )}
    </div>
  );
};

AddressDetailsForm.propTypes = {
  setAddressFormSuccess: PropTypes.func.isRequired,
};

export default AddressDetailsForm;